import React from "react";
import createReactClass from "create-react-class";

import Chip from "@javascript/reactComponents/lds/chips/Chip";
import { createPathMatcher, getPageFromUrl, parseUrlSegments } from "@javascript/helpers/urlUtilities";
import FacetSearchStore from "@javascript/stores/facetSearchStore";

const PAGE_PATTERNS = [
  {
    pattern: "facet_search",
    matcher: createPathMatcher(['facet_search']),
    clearAll: () => {
      window.location.href = '/facet_search';
    }
  },
  {
    pattern: "mapping",
    matcher: createPathMatcher(['mapping']),
    clearAll:  () => {
      window.location.href = '/mapping?time_select=time_any';
    }
  },
  {
    pattern: "events",
    matcher: createPathMatcher(['company', '*', 'events']),
    clearAll:  (segments) => {
      window.location.href = `/company/${segments[1]}/events?time_select=time_any`;
    }
  },
  {
    pattern: "display_saved_feed",
    matcher: createPathMatcher(['feeds', '*', 'display_saved_feed']),
    clearAll:  (segments) => {
      window.location.href = `/feeds/${segments[1]}/display_saved_feed?time_select=time_any`;
    }
  },
  {
    pattern: "feeds",
    matcher: createPathMatcher(['feeds', '*']),
    clearAll: (segments) => {
      window.location.href = `/feeds/${segments[1]}?time_select=time_any`;
    }
  },
  {
    pattern: "edit",
    matcher: createPathMatcher(['feeds', '*', 'edit']),
    clearAll: () => {
      FacetSearchStore.init();
      FacetSearchStore.trigger(FacetSearchStore.data);
      doEventSearch();
    }
  }
];

const isInOriginalQuery = (queryKey, value, originalQuery) => {
  if (!originalQuery) return false;

  switch(queryKey) {
    case 'activities':
      return originalQuery.category === value;

    case 'affiliation':
      return Array.isArray(originalQuery.entity_list_refs) &&
        Object.keys(value?.orgListRefs || {}).every(ref =>
          originalQuery.entity_list_refs.includes(ref)
        );

    case 'aliasSearch':
      return Array.isArray(originalQuery.alias_search_refs) &&
        originalQuery.alias_search_refs.includes(value);

    case 'clin_stage':
      return Array.isArray(originalQuery.clin_stage) &&
        originalQuery.clin_stage.includes(value);

    case 'clin_status':
      return Array.isArray(originalQuery.clin_status) &&
        originalQuery.clin_status.includes(value);

    case 'filter_criteria':
      // If being called with individual values, treat as direct comparison
      if (Array.isArray(value) || typeof value !== 'object') {
        const facetMatch = Object.values(originalQuery.facets || {}).some(facetValues =>
          Array.isArray(facetValues) && _.isEqual(facetValues, value)
        );
        return facetMatch;
      }

      // If being called with full criteria object, check all facets
      return Object.entries(value).every(([facetKey, facetValues]) => {
        return _.isEqual(originalQuery.facets[facetKey], facetValues);
      });

    case 'geo_coordinates':
      return originalQuery.geo_box && _.isEqual(value, originalQuery.geo_box);

    case 'location':
      return Array.isArray(originalQuery.loc_codes) &&
        originalQuery.loc_codes.includes(value);

    case 'org_lists':
      return originalQuery.org_list_id === value?.orgListId;

    case 'relationships':
      return Array.isArray(originalQuery.relationships) &&
        originalQuery.relationships.includes(value);

    case 'query':
      return originalQuery.query === value?.queryTerm;

    case 'time_frame':
      // There is no time_frame in original query structure, so this is always new
      return false;

    case 'user_lists':
      return originalQuery.org_list_id === value?.selected?.orgListId;

    default:
      return false;
  }
};

const FILTER_COUNTERS = {
  activities: {
    isValid: (activities) => activities?.selected && activities.selected !== 'all_event',
    count: (activities) => {
      const originalQuery = Zymewire.original_feed_query;
      return isInOriginalQuery('activities', activities?.selected, originalQuery) ? 0 : 1
    }
  },

  affiliation: {
    isValid: (affiliation) => !_.isEmpty(affiliation?.orgListRefs),
    count: (affiliation) => {
      const originalQuery = Zymewire.original_feed_query;
      if (!affiliation?.orgListRefs) return 0;
      return Object.entries(affiliation.orgListRefs)
        .filter(([ref]) => !isInOriginalQuery('affiliation', ref, originalQuery))
        .length;
    }
  },

  aliasSearch: {
    isValid: (alias) => alias?.aliasSearchRefs?.length > 0,
    count: (alias) => {
      const originalQuery = Zymewire.original_feed_query;
      if (!alias?.aliasSearchRefs) return 0;
      return alias.aliasSearchRefs
        .filter(ref => !isInOriginalQuery('alias_search', ref, originalQuery))
        .length;
    }
  },

  clinicalTrialStages: {
    isValid: (stages) => stages?.selected?.length > 0,
    count: (stages) => {
      const originalQuery = Zymewire.original_feed_query;
      if (!stages?.selected) return 0;
      return stages.selected
        .filter(stage => !isInOriginalQuery('clin_stage', stage, originalQuery))
        .length;
    }
  },

  clinicalTrialStatuses: {
    isValid: (statuses) => statuses?.selected?.length > 0,
    count: (statuses) => {
      const originalQuery = Zymewire.original_feed_query;
      if (!statuses?.selected) return 0;
      return statuses.selected
        .filter(status => !isInOriginalQuery('clin_status', status, originalQuery))
        .length;
    }
  },

  filterCriteria: {
    isValid: (criteria) => !_.isEmpty(criteria),
    count: (criteria) => {
      const originalQuery = Zymewire.original_feed_query;
      const currentPage = getPageFromUrl(PAGE_PATTERNS, "facet_search");
      const isCompanyEventsPage = currentPage === "events";

      // Remove _id field and get entries
      const criteriaWithoutId = _.omit(criteria, ['_id']);
      let totalCount = 0;

      // For each filter type (organizations, conditions, etc)
      Object.entries(criteriaWithoutId).forEach(([_, filterValues]) => {
        // Check if this filter exists in original query
        const isMatchingOriginal = isInOriginalQuery('filter_criteria', filterValues, originalQuery);

        if (!isMatchingOriginal) {
          // If it's an array (like organizations: ["Pfizer"]), count each value
          if (Array.isArray(filterValues)) {
            totalCount += filterValues.length;
          }
          // If it's a single value and it exists, count as 1
          else if (filterValues) {
            totalCount += 1;
          }
        }
      });

      // On company events page, reduce count by 1 to account for company
      if (isCompanyEventsPage) {
        return Math.max(0, totalCount - 1);
      }

      return totalCount;
    }
  },

  geoCoordinates: {
    isValid: (coords) => coords?.bottom_right_lat !== null,
    count: (coords) => {
      const originalQuery = Zymewire.original_feed_query;
      if (getPageFromUrl(PAGE_PATTERNS, "facet_search") === "mapping") return 0;
      return isInOriginalQuery('geo_coordinates', coords, originalQuery) ? 0 : 1;
    }
  },

  location: {
    isValid: (location) => location?.selectedLocationCodes?.length > 0,
    count: (location) => {
      const originalQuery = Zymewire.original_feed_query;
      if (!location?.selectedLocationCodes) return 0;
      return location.selectedLocationCodes
        .filter(code => !isInOriginalQuery('location', code, originalQuery))
        .length;
    }
  },

  relationships: {
    isValid: (relationships) => relationships?.selected?.length > 0,
    count: (relationships) => {
      const originalQuery = Zymewire.original_feed_query;
      if (!relationships?.selected) return 0;
      return relationships.selected
        .filter(rel => !isInOriginalQuery('relationships', rel, originalQuery))
        .length;
    }
  },

  searchTerm: {
    isValid: (term) => {
      if (!term) return false;
      return Object.values(term).some(value =>
        value &&
        value !== '' &&
        value !== null &&
        (typeof value === 'string' ? value.trim() !== '' : true)
      );
    },
    count: (term) => {
      const originalQuery = Zymewire.original_feed_query;
      return isInOriginalQuery('query', term, originalQuery) ? 0 : 1
    }
  },

  timeFrame: {
    isValid: (timeFrame) => timeFrame?.selected && timeFrame.selected !== 'time_any',
    count: (timeFrame) => {
      const originalQuery = Zymewire.original_feed_query;
      return isInOriginalQuery('time_frame', timeFrame?.selected, originalQuery) ? 0 : 1
    }
  },

  userLists: {
    isValid: (lists) => lists?.selected,
    count: (lists) => {
      const originalQuery = Zymewire.original_feed_query;
      return isInOriginalQuery('org_list_id', lists?.selected, originalQuery) ? 0 : 1
    }
  }
};

const AppliedFiltersClearAll = createReactClass({
  mixins: [Reflux.connect(FacetSearchStore, "appliedFilters")],

  getInitialState() {
    return {
      appliedFilters: {}
    };
  },

  countAppliedFilters() {
    const filters = this.state.appliedFilters;
    if (!filters) return 0;

    const originalQuery = Zymewire.original_feed_query;

    return Object.entries(FILTER_COUNTERS).reduce((total, [key, counter]) => {
      const isValidResult = counter.isValid(filters[key]);
      if (isValidResult) {
        const count = counter.count(filters[key]);
        return total + count;
      }
      return total;
    }, 0);
  },

  handleClearAll() {
    $("body").addClass("wait");

    const currentPath = window.location.pathname;
    const segments = parseUrlSegments(currentPath);
    const currentPage = getPageFromUrl(PAGE_PATTERNS, "facet_search");

    const matchedPattern = PAGE_PATTERNS.find(p => p.pattern === currentPage);

    if (matchedPattern) {
      if(typeof matchedPattern.clearAll === "function") {
        matchedPattern.clearAll(segments);
      }
      else {
        window.location.href = "/facet_search";
      }
    }
    else {
      window.location.href = "/facet_search";
    }
  },

  render() {
    const filterCount = this.countAppliedFilters();

    if (filterCount === 0) return null;

    return (
      <div className="applied_filters_clear_all">
        <Chip
          label={`Clear Filters (${filterCount})`}
          onClick={this.handleClearAll}
          size="small"
          variant="secondary"
          width="100%"
        />
      </div>
    );
  }
});

export default AppliedFiltersClearAll;
